import { InputHTMLAttributes } from "react";
import { InputAXS } from "../styles";

interface Props {
  type?:
    | "text"
    | "number"
    | "color"
    | "date"
    | "datetime-local"
    | "email"
    | "hidden"
    | "month"
    | "password"
    | "time"
    | "range"
    | "search"
    | "tel"
    | "url"
    | "week";
  label?: string;
  span?: any;
  id?: string;
  error?: string;
  maxLength?: string;
  width?: number;
}

type InputProps = InputHTMLAttributes<HTMLInputElement> & Props;

export function InputRaw({
  type,
  label,
  span,
  id,
  error,
  maxLength,
  width,
  ...rest
}: InputProps) {
  return (
    <InputAXS className="input-AXS" width={width}>
      <span>{span}</span>
      <input type={type || "text"} maxLength={maxLength} {...rest} />
      <label htmlFor={id}>{label}</label>
      {error && <span>{error}</span>}
    </InputAXS>
  );
}